/** Executive Minimal metric row — the audit's "clean structured panel of numbers"
 *  pattern.  Not four giant colourful cards. */
export default function MetricRow({ items, testId }) {
  return (
    <div className="st-metric-row" data-testid={testId}>
      {items.map((it) => (
        <MetricCell key={it.label} {...it} />
      ))}
    </div>
  );
}

export function MetricCell({ label, value, hint, onClick, testId, tone }) {
  const Cmp = onClick ? "button" : "div";
  return (
    <Cmp onClick={onClick} className="st-metric-cell text-left" data-testid={testId}>
      <div className="st-overline">{label}</div>
      <div className={"st-metric st-metric-lg " + (tone === "accent" ? "text-[color:var(--st-accent)]" : "")}>
        {value ?? "—"}
      </div>
      {hint && <div className="text-[11px] text-[color:var(--st-text-muted)]">{hint}</div>}
    </Cmp>
  );
}
